// ChildNode.remove() polyfill
// https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('remove')) {
            return;
        }

        Object.defineProperty(item, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                this.parentNode.removeChild(this);
            }
        });
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);


// FIXME: Adding custom functions to Array's prototype breaks MobX.

/**
 * Counts how many elements meet specified condition.
 *
 * @param {Function} comparator
 * @return {Number}
 */
/*Array.prototype.count = function (comparator) {
    return this.filter(comparator).length
};*/

/**
 * Returns a random value from the array.
 * @return {any}
 */
/*Array.prototype.random = function () {
    return this[Math.floor(Math.random() * this.length)]
};*/

String.prototype.firstCharacterLowerCase = function () {
    if (this.length < 1) {
        return this
    }

    return this.substr(0, 1).toLowerCase() + this.substr(1, this.length)
};

String.prototype.toCamelCase = function () {
    return this.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
        if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
        return index == 0 ? match.toLowerCase() : match.toUpperCase();
    });
}

Array.prototype.partition = function (size) {
    var index = 0;
    var arrayLength = this.length;
    var tempArray = [];

    for (index = 0; index < arrayLength; index += size) {
        var myChunk = this.slice(index, index + size);
        tempArray.push(myChunk);
    }

    return tempArray;
}

Array.prototype.grouping = function (n) {
    var count = Math.ceil(this.length / n);
    var parts = [];

    var index = 0;
    for (var i = 0; i < n; i++) {
        parts.push(this.slice(index, index + count));
        index += count;
    }

    return parts;
}